var React = require('react');

function EditContent (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M12.17 17.78l-4.95-4.95 8.038-8.037a1.1 1.1 0 0 1 1.555 0l3.394 3.394a1.1 1.1 0 0 1 0 1.555L12.17 17.78z","fill":"#C11D17","key":0}),React.createElement("path",{"d":"M7.164 17.279l.056-4.449 4.95 4.95-4.449.056a.55.55 0 0 1-.557-.557z","fill":"#CDCCC8","key":1}),React.createElement("path",{"d":"M7.16 17.56L7.18 16l1.818 1.82-1.559.02a.275.275 0 0 1-.278-.28z","fillOpacity":".75","fill":"#000","key":2})]));
}

EditContent.defaultProps = {"width":"25","height":"25"};

module.exports = EditContent;

EditContent.default = EditContent;
